export default __webpack_public_path__ + "static/media/rousseau.bdef0297.jpg";